import React, { PropTypes } from 'react';

import './PageHeader.scss';
import HeroSection from '../../containers/Home/HeroSection';

const PageHeader = ({ style, children, isHomePage = false }) => (
  <div className={`page-header bg-gray-100 py-8 ${isHomePage && "remove-padding-header"}`} style={style}>
      {isHomePage && <HeroSection />}
     {isHomePage && <div
        class="trustpilot-widget"
        data-locale="en-GB"
        data-template-id="5419b6a8b0d04a076446a9ad"
        data-businessunit-id="5f32a8e6f15a1a0001626989"
        data-style-height="48px"
        data-style-width="100%"
        data-theme="light"
        data-min-review-count="10"
        data-style-alignment="center"
        style={{ margin: '1rem 0', zIndex: 99999999 }}
        >
        <a
          href="https://uk.trustpilot.com/review/brightonsbm.com"
          target="_blank"
          rel="noopener">
          Trustpilot
        </a>
      </div>}
    <div className="container mx-auto px-4">
      <div className="title-wrapper">{children}</div>
    </div>
  </div>
);

export default PageHeader;
